import { DEFAULT_CRITERIA } from 'consts/targetCriteria';
import { NetworkReferenceOptions, NetworkReferenceResponse } from 'store/userOptions/reducer.types';
import { TargetCriteria } from './getPublisherDefaultCriteria';

type TransformAvailableNetworksParams = {
  availableNetworks: NetworkReferenceResponse[];
  networksAvailability?: Record<string, number>;
  defaultCriteria?: TargetCriteria;
};

export const transformAvailableNetworks = ({
  availableNetworks,
  networksAvailability = {},
  defaultCriteria = DEFAULT_CRITERIA,
}: TransformAvailableNetworksParams): NetworkReferenceOptions => {
  const transformed: NetworkReferenceOptions = {};

  availableNetworks.forEach(({ name, networks }) => {
    if (!transformed[name]) {
      transformed[name] = [];
    }

    const structuredNetworks = networks.map(({ code, assets, name: networkName }) => {
      return {
        code,
        name: networkName,
        target: '',
        priority: defaultCriteria.priority,
        greenTolerance: defaultCriteria.greenTolerance,
        orangeTolerance: defaultCriteria.orangeTolerance,
        allocated: 0,
        available: networksAvailability[code],
        inNetwork: assets,
      };
    });

    transformed[name].push(...structuredNetworks);
  });

  return transformed;
};
